$(document).one('turbo:load', function () {
	if (!$('.static_pages.faq').length) return;
	if (window.faqPageInitialized) return;
	window.faqPageInitialized = true;
	toggleFAQ($('.faq_question_container').first(), 0);

	$('.faq_question_container').click(function () {
		toggleFAQ(this, 200);
	});

	function toggleFAQ(tab, animation) {
		$(tab).toggleClass('faq_active');
		$('.faq_answer_container[data-id="' + $(tab).attr('data-id') + '"]').slideToggle(animation);
	}
});